import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";  
import "./App.css";   
import App from "./App";
import reportWebVitals from "./reportWebVitals";


// Suppress ResizeObserver error - it's a known issue in development
const originalError = console.error;
console.error = (...args) => {
  if (/ResizeObserver loop completed with undelivered notifications/.test(args[0])) {
    return;
  }
  originalError.call(console, ...args);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

